import React from 'react';

const ComingSoonSVG = () => {
  return (
    <svg
      height="300"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 990 808.857"
    >
      <path
        fill="#f2f2f2"
        d="M1047.085 354.958c-44.917-176.621-200.117-304.117-382.289-309.23-96.308-2.704-197.652 29.237-271.437 141.011-131.9 199.809 8.105 337.882 105.713 403.492a610.757 610.757 0 01126.241 113.465c65.931 78.238 192.767 175.46 343.824 23.128 109.485-110.41 107.866-254.218 77.948-371.866z"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#3f3d56"
        d="M1095 625.244c0 84.038-213.166 229.185-486.546 229.185S105 713.039 105 629.002s410.465-216.035 503.454-78.9S1095 541.207 1095 625.244z"
        transform="translate(-105 -45.571)"
      />
      <path
        d="M1095 625.244c0 84.038-213.166 229.185-486.546 229.185S105 713.039 105 629.002s410.465-216.035 503.454-78.9S1095 541.207 1095 625.244z"
        opacity="0.1"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#3f3d56"
        d="M1095 629.002c0 84.037-221.619 152.163-495 152.163s-495-68.126-495-152.163 402.011-289.298 495-152.164 495 68.126 495 152.164z"
        transform="translate(-105 -45.571)"
      />
      <ellipse
        cx="686.613"
        cy="609.73"
        opacity="0.1"
        rx="144.649"
        ry="54.478"
      />
      <ellipse
        cx="105.199"
        cy="575.916"
        opacity="0.1"
        rx="77.021"
        ry="29.008"
      />
      <path
        fill="#2f2e41"
        d="M126.318 495.442c0 60.129 37.722 108.785 84.339 108.785"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#191e38"
        d="M210.657 604.227c0-60.805 42.095-110.007 94.117-110.007M156.875 500.893c0 57.116 24.055 103.334 53.782 103.334"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#2f2e41"
        d="M210.657 604.227c0-77.695 48.655-140.565 108.784-140.565"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#a8a8a8"
        d="M192.914 604.994s11.96-.369 15.565-2.936 18.398-5.631 19.293-1.515 17.974 20.474 4.47 20.583-31.375-2.103-34.973-4.295-4.355-11.837-4.355-11.837z"
        transform="translate(-105 -45.571)"
      />
      <path
        d="M232.484 619.693c-13.504.11-31.376-2.103-34.974-4.295-2.74-1.669-3.832-7.657-4.197-10.42l-.4.016s.758 9.646 4.356 11.837 21.47 4.404 34.974 4.295c3.898-.031 5.244-1.418 5.17-3.472-.541 1.241-2.028 2.016-4.93 2.04z"
        opacity="0.2"
        transform="translate(-105 -45.571)"
      />
      <ellipse
        cx="380.502"
        cy="432.026"
        opacity="0.1"
        rx="99.269"
        ry="37.387"
      />
      <path
        fill="#2f2e41"
        d="M377.39 315.142c0 77.498 48.619 140.209 108.702 140.209"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#191e38"
        d="M486.092 455.35c0-78.368 54.255-141.783 121.303-141.783M416.775 322.168c0 73.614 31.003 133.183 69.317 133.183"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#2f2e41"
        d="M486.092 455.35c0-100.137 62.71-181.167 140.208-181.167"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#a8a8a8"
        d="M463.224 456.34s15.415-.476 20.061-3.784 23.713-7.258 24.866-1.953 23.166 26.388 5.762 26.529-40.439-2.711-45.076-5.536-5.613-15.257-5.613-15.257z"
        transform="translate(-105 -45.571)"
      />
      <path
        d="M514.224 475.285c-17.404.14-40.44-2.711-45.076-5.536-3.532-2.15-4.939-9.869-5.41-13.43-.326.014-.514.02-.514.02s.976 12.433 5.613 15.257 27.672 5.676 45.076 5.536c5.024-.04 6.76-1.828 6.664-4.476-.698 1.6-2.614 2.599-6.353 2.629z"
        opacity="0.2"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#2f2e41"
        d="M667.408 54.953a46.524 46.524 0 0146.523 46.523V148h-93.047v-46.524a46.524 46.524 0 0146.524-46.523z"
      />
      <path
        fill="#ffb9b9"
        d="M811.44 190.812l-.678 4.392-2.476 16.11v24.444L779.9 249.163l-26.022 2.366-10.251-33.481-1.577-5.157s.457-.308 1.254-.836c.694-.473 1.656-1.12 2.807-1.893a899.81 899.81 0 0013.287-9.1c7.885-5.52 0-39.426 0-39.426l26.021-2.366s2.366 6.308 4.732 19.714c1.774 10.053 12.86 11.678 18.294 11.86a26.42 26.42 0 002.996-.032z"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#ffb9b9"
        d="M622.855 514.276L622.855 572.627 638.626 572.627 646.511 511.91 622.855 514.276z"
      />
      <path
        fill="#2f2e41"
        d="M736.53 598.485l-9.463-1.577s-3.943 31.542-7.886 38.639-25.233 36.272-13.405 37.85 27.6 0 28.388-3.943 7.096-27.6 7.885-26.022 0 17.348 0 17.348h3.154v-18.925s13.405-9.463 9.463-14.194-7.886-16.56-7.886-16.56l.789-11.827z"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#ffb9b9"
        d="M742.713 514.276L742.713 572.627 726.942 572.627 719.057 511.91 742.713 514.276z"
      />
      <path
        fill="#2f2e41"
        d="M839.04 598.485l9.462-1.577s3.942 31.542 7.885 38.639 25.233 36.272 13.405 37.85-27.599 0-28.387-3.943-7.097-27.6-7.886-26.022 0 17.348 0 17.348h-3.154v-18.925s-13.405-9.463-9.462-14.194 7.885-16.56 7.885-16.56L828 599.275z"
        transform="translate(-105 -45.571)"
      />
      <circle cx="667.013" cy="101.871" r="29.964" fill="#ffb9b9" />
      <path
        fill="#ffb9b9"
        d="M865.85 278.34l-19.714 73.333-2.366 26.022-14.193-26.022s7.885-11.828 9.462-19.713 8.674-49.678 8.674-49.678l-22.174-47.667-.914-1.964-7.665-.047-7.885-10.251 4.73-12.617v-9.462l-3.043-5.07-1.687-2.815 2.365-1.577 12.617-1.578a5.339 5.339 0 011.545.103c3.304.607 11.284 4.234 17.38 24.342 7.885 26.022 22.867 64.66 22.867 64.66zM753.877 268.877v47.312l-26.022 72.545s-6.308 29.965-25.233 31.542 12.617-35.484 12.617-35.484l20.502-78.065v-41.004s-5.52-21.29-7.097-30.753c-1.175-7.066 1.159-14.565 2.42-17.916.426-1.135.734-1.798.734-1.798l10.251-3.154 1.254-.047.323 5.993.789 14.556z"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#ffb9b9"
        d="M818.537 295.687s5.52 17.348 6.308 18.136-17.347 3.943-17.347 3.943h-34.696l-17.348-7.885 1.577-14.983z"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#2f2e41"
        d="M827.211 305.938s-1.577 17.348 2.366 23.656 14.193 18.136 17.347 52.832 7.097 165.593 8.674 171.113 6.309 12.616 1.577 13.405-41.792 9.462-41.792 0 0-12.617-2.366-14.194-30.753-125.377-30.753-125.377l-26.021 128.531s10.25 14.194-5.52 12.617-43.37-3.943-40.216-11.828a77.034 77.034 0 003.943-11.828l15.77-141.937s3.155-59.929 23.657-91.865l1.577-7.6s29.176 2.475 39.427 5.63 32.33-3.155 32.33-3.155z"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#ff6584"
        d="M825.54 234.615c-.663 8.618-4.574 60.023-3.849 65.803 0 0 3.943 4.731-7.885 2.366s-46.524 0-50.467.788-8.673 3.943-8.673-1.577 1.577-22.079-.789-24.444-14.194-22.868-13.405-28.388c.568-3.966-5.78-22.165-9.407-32.109.425-1.135.733-1.798.733-1.798l10.251-3.154 1.254-.047c.694-.473 1.656-1.12 2.807-1.893l3.824 18.5 1.577 6.308s26.022 0 46.524-14.983l10.409-29.144a26.42 26.42 0 002.996-.031l12.617-1.578a5.339 5.339 0 011.545.103l-11.796 35.382 10.819 7.932 1.009.742s-.032.433-.095 1.222z"
        transform="translate(-105 -45.571)"
      />
      <path
        fill="#2f2e41"
        d="M688.698 95.956L646.906 95.956 637.443 71.512 695.795 71.512 688.698 95.956z"
      />
      <ellipse
        cx="742.443"
        cy="153.356"
        fill="#ffb9b9"
        rx="2.366"
        ry="6.308"
        transform="rotate(-16.16 529.442 500.377)"
      />
      <ellipse
        cx="801.584"
        cy="153.356"
        fill="#ffb9b9"
        rx="6.308"
        ry="2.366"
        transform="rotate(-73.84 718.758 200.443)"
      />
      <path fill="#fff" d="M440.522 361.76H602.078V567.462H440.522z" />
      <rect
        width="107.078"
        height="30.057"
        x="467.761"
        y="414.83"
        fill="#2f2e41"
        rx="2.774"
      />
      <circle cx="549.478" cy="420.465" r="2.818" fill="#191e38" />
      <circle cx="557.932" cy="420.465" r="2.818" fill="#191e38" />
      <circle cx="566.385" cy="420.465" r="2.818" fill="#191e38" />
      <rect
        width="107.078"
        height="30.057"
        x="467.761"
        y="449.583"
        fill="#2f2e41"
        rx="2.774"
      />
      <circle cx="549.478" cy="455.219" r="2.818" fill="#191e38" />
      <circle cx="557.932" cy="455.219" r="2.818" fill="#191e38" />
      <circle cx="566.385" cy="455.219" r="2.818" fill="#191e38" />
      <rect
        width="107.078"
        height="30.057"
        x="467.761"
        y="484.336"
        fill="#2f2e41"
        rx="2.774"
      />
      <circle cx="549.478" cy="489.972" r="2.818" fill="#191e38" />
      <circle cx="557.932" cy="489.972" r="2.818" fill="#191e38" />
      <circle cx="566.385" cy="489.972" r="2.818" fill="#191e38" />
    </svg>
  );
};

export default ComingSoonSVG;
